// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
import * as Sentry from "@sentry/nextjs";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig();
const { sentry, host, apiUrl, app, analytics } = publicRuntimeConfig;

Sentry.init({
  // dsn: sentry.dsn,
  dsn: 'https://b81dd42176954b68b43520421325bcbc@o1300912.ingest.sentry.io/6701947',
  // To set a uniform sample rate
  tracesSampleRate: 0,
  debug: app.env.isDev,
  environment: sentry.environment,
  autoBreadcrumbs: true,
  captureUnhandledRejections: true,
  beforeSend: function(event, hint) {
    // filter out UnhandledRejection errors that have no information
    if (event && event.exception && event.exception.values && event.exception.values.length == 1) {
      var e = event.exception.values[0];
      if (e.type === 'UnhandledRejection' && e.value.startsWith('Non-Error promise rejection captured with value:')) {
        return null;
      }
    }
  },
  initialScope: {
    tags: {
      runtimeEngine: "browser",
      version: app.version,
      host: host,
      apiUrl: apiUrl,
      locale: navigator?.language,
      is_analytics_enable: analytics.enable,
    },
  },
  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    // Instagram error that Meta isn't fixing but is not impacting users
    // See https://developers.facebook.com/community/threads/320013549791141/
    '_AutofillCallbackHandler',
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Woopra flakiness
    /eatdifferent\.com\.woopra-ns\.com/i,
    /static\.woopra\.com\/js\/woopra\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Other plugins
    /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
    /webappstoolbarba\.texthelp\.com\//i,
    /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
  ],
});
